import { Box, Chip, Stack, IconButton, Tooltip } from "@mui/material";
import { DataGrid, type GridColDef } from "@mui/x-data-grid";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import DeleteIcon from "@mui/icons-material/Delete";
import type { BuyerBossWithBuyerCode } from "@/api/buyerBossService";

interface BuyerBossTableProps {
  data: BuyerBossWithBuyerCode[];
  isLoading: boolean;
  canEdit: boolean;
  onEdit: (row: BuyerBossWithBuyerCode) => void;
  onDelete: (row: BuyerBossWithBuyerCode) => void;
}

const BuyerBossTable = ({
  data,
  isLoading,
  canEdit,
  onEdit,
  onDelete,
}: BuyerBossTableProps) => {
  const columns: GridColDef<BuyerBossWithBuyerCode>[] = [
    {
      field: "action",
      headerName: "Action",
      width: 120,
      headerAlign: "center",
      align: "center",
      headerClassName: "custom-header",
      sortable: false,
      renderCell: (params) => (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            justifyContent: "center",
            gap: 0.5,
          }}
        >
          <Tooltip title="แก้ไข" placement="top">
            <IconButton onClick={() => onEdit(params.row)} disabled={!canEdit}>
              <BorderColorIcon color={canEdit ? "primary" : "disabled"} />
            </IconButton>
          </Tooltip>
          <Tooltip title="ลบ" placement="top">
            <IconButton
              onClick={() => onDelete(params.row)}
              disabled={!canEdit}
            >
              <DeleteIcon color={canEdit ? "error" : "disabled"} />
            </IconButton>
          </Tooltip>
        </Box>
      ),
    },
    {
      field: "employee_id",
      headerName: "รหัสพนักงาน",
      width: 130,
      headerClassName: "custom-header",
    },
    {
      field: "name",
      headerName: "ชื่อ",
      minWidth: 180,
      flex: 0.3,
      headerClassName: "custom-header",
    },
    {
      field: "email",
      headerName: "Email",
      minWidth: 220,
      flex: 0.25,
      headerClassName: "custom-header",
    },
    {
      field: "buyer_code",
      headerName: "Buyer Code",
      minWidth: 250,
      flex: 0.4,
      headerClassName: "custom-header",
      sortable: false,
      renderCell: (params) => (
        <Stack
          direction="row"
          spacing={0.5}
          sx={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            flexWrap: "wrap",
            gap: 0.5,
          }}
        >
          {params.row.buyer_code?.map((code) => (
            <Chip label={code} color="info" size="small" key={code} />
          ))}
        </Stack>
      ),
    },
  ];

  return (
    <Box sx={{ width: "100%", mt: 1 }}>
      <DataGrid
        rows={data}
        columns={columns}
        loading={isLoading}
        getRowId={(row) => row.employee_id}
        initialState={{
          pagination: {
            paginationModel: { pageSize: 10 },
          },
        }}
        pageSizeOptions={[10, 20, 50]}
        disableRowSelectionOnClick
        disableColumnSelector
        disableColumnFilter
        disableColumnMenu
        sx={{ maxHeight: "70vh", overflow: "auto" }}
      />
    </Box>
  );
};

export default BuyerBossTable;
